import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import type { BillingPlanId } from "@/services/api/billingService"
import { Check } from "lucide-react"
import { PLAN_COPY } from "./planCopy"

/** What a plan includes; the same list on the plan card and in the checkout summary. */
export const PlanFeatures: React.FC<{ plan: BillingPlanId }> = ({ plan }) => {
  const { translate } = useTranslation()
  return (
    <ul className="flex flex-col gap-2.5">
      {PLAN_COPY[plan].features.map((feature) => (
        <li key={feature} className="flex items-start gap-2">
          <Check
            className="mt-0.5 size-4 shrink-0 text-muted-foreground"
            aria-hidden="true"
          />
          <Typography as="small">{translate(feature)}</Typography>
        </li>
      ))}
    </ul>
  )
}
